
import Vue from 'vue';
import { mask } from 'vue-the-mask';
import { ValidationProvider } from 'vee-validate';
import Tooltip from '@/components/Tooltip/index.vue';
import {
  StyledInput,
  StyledLabel,
  StyledLabelError,
  Icon,
  Type,
  WrapperIcon,
  WrapperInput,
} from './styles';

export default Vue.extend({
  name: 'InputWithValidation',
  components: {
    StyledInput,
    StyledLabel,
    StyledLabelError,
    Tooltip,
    WrapperIcon,
    WrapperInput,
    ValidationProvider,
  },
  props: {
    disable: {
      type: Boolean,
      default: false,
    },
    vid: {
      type: String,
    },
    rules: {
      type: [Object, String],
      default: '',
    },
    error: {
      type: Boolean,
      default: false,
    },
    errorMessage: String,
    icon: {
      type: String,
      default: '',
      validator(value: typeof Icon[number]) {
        return Icon.indexOf(value) !== -1;
      },
    },
    label: {
      type: String,
      default: '',
    },
    mask: {
      type: Array,
    },
    name: {
      type: String,
      default: '',
    },
    placeholder: {
      type: String,
      default: '',
    },
    primary: {
      type: Boolean,
      default: false,
    },
    small: {
      type: Boolean,
      default: false,
    },
    tooltip: {
      type: String,
      default: '',
    },
    type: {
      type: String,
      default: 'text',
      validator(value: typeof Type[number]) {
        return Type.indexOf(value) !== -1;
      },
    },
    value: String,
  },
  directives: {
    mask: {
      bind(el, binding, vnode, oldVnode) {
        if (binding.value) mask(el, binding, vnode, oldVnode);
      },
    },
  },
  data() {
    return {
      iconColors: {
        eye: 'gray',
        search: 'white',
      },
      iconName: this.icon.toLowerCase(),
      inputType: this.type,
      innerValue: '',
    };
  },
  watch: {
    innerValue(val: string) {
      this.$emit('input', val);
    },
    value(val: string) {
      this.innerValue = val;
    },
  },
  created() {
    if (this.value) {
      this.innerValue = this.value;
    }
  },
});
